import axios from 'axios'

const language = document.documentElement.lang

export default {
  recipes: {
    baseUrl: `/${language}/api/search/recipes`,
    get({
      skip = 0,
      pageSize = 0,
      tags = [],
      sortOrder,
      searchTerms = [],
      cancelToken
    }) {
      const searchParams = new URLSearchParams()
      if (skip + pageSize > 0) {
        searchParams.append('skip', skip + pageSize)
      }
      tags.forEach((tag) => {
        searchParams.append('tags', tag)
      })
      searchParams.append('sortOrder', sortOrder)
      searchTerms.forEach((term) => {
        searchParams.append('searchTerms', term)
      })

      return axios.get(this.baseUrl, {
        cancelToken: cancelToken?.token,
        params: searchParams
      })
    }
  },
  search: {
    baseUrl: `/${language}/api/facet/search`,
    get({ query, tagUids, cancelToken }) {
      const searchParams = new URLSearchParams()
      searchParams.append('query', query)
      tagUids.forEach((uid) => {
        searchParams.append('tagUids', uid)
      })

      return axios.get(this.baseUrl, {
        cancelToken: cancelToken?.token,
        params: searchParams
      })
    }
  }
}
